export type DivProps = React.JSX.IntrinsicElements["div"];

export const ThemedView = (
    props: {
        disabled?: boolean;
    } & DivProps,
) => {
    return (
        <div
            {...props}
            style={{
                cursor:
                    props.onClick && !props.disabled ? "pointer" : undefined,
                display: "flex",
                flexDirection: "column",
                padding: "0px",
                margin: "0px",
                ...props.style,
            }}
            onClick={
                props.onClick
                    ? (e) => {
                          if (props.disabled) {
                              return;
                          }
                          props.onClick?.(e);
                      }
                    : undefined
            }
        >
            {props.children}
        </div>
    );
};
